import React from 'react'
import { useLocation } from 'react-router-dom'

import {
	Row,
	Col
} from 'react-bootstrap'
import styles from './RouterTemplate.module.scss'

import Router from './Router'
import Nav from './components/layout/Nav'
import Sidebar from './components/layout/Sidebar'

import { StateProvider } from './StateContext'

const RouteTemplate = () => {
	const location = useLocation()
	const fullSizePage: string[] = ['/login', '/forgotpassword', '/resetpassword', '/setnewpassword']
	return !fullSizePage.some(element => location.pathname.includes(element)) ?
		(
			<StateProvider>
				<Row>
					<Col md={12}>
						{/* <div className={styles.sideBar}>
							<Sidebar />
						</div> */}
						<div className={styles.appBody}>
							<Nav />
							<Router />
						</div>
					</Col>
				</Row>
			</StateProvider>
		) : (
			<div className={styles.loginBody}>
				<StateProvider>
					<Router />
				</StateProvider>
			</div>
		)
}

export default RouteTemplate